<template>
  <div>
    <layout headerTitle="Sistema de vigilancia epidemiológico">
      <template #container>
        <b-row class="pt-4 pb-5">
          <div style="display: flex; left: 15px; margin-bottom: 10px">
            <label class="mr-2 breadcrumb-link"
              ><button
                class="mt-0 p-0 pb-1 d-flex align-items-center breadcrumb-link back"
                style="
                  border: none;
                  background-color: transparent;
                  font-size: 16px;
                "
                @click.prevent="back"
              >
                Volver atrás
              </button></label
            >
          </div>
          <b-col cols="12">
            <img
              alt="group"
              :src="require('@/assets/modules/health-tracker/icon/group.svg')"
            />
            <strong class="pl-2">{{ nameForm }} PCL</strong>
          </b-col>
        </b-row>

        <b-row class="mb-5">
          <b-col cols="12">
            <strong>Datos del trabajador</strong>
            <worker-information :id="employeeId" />
          </b-col>
        </b-row>

        <!-- opciones -->
        <FormPCL
          @changeForm="changeForm"
          :diagnostics="diagnostics"
          :isBusy="isBusy"
          :loading="loading"
          :record="record"
          :isEdit="isEdit"
        />

        <hr class="hr-form-ipt" />
        <b-row class="mt-5" v-if="isValidation && !loading && !isEdit">
          <b-col cols="12">
            <b-alert show variant="danger" class="alert-danger-form-ipt">
              <div class="d-flex align-items-center">
                <div class="mr-3">
                  <img
                    src="@/assets/images/icons/icon-danger.svg"
                    alt=""
                    width="28px"
                    height="28px"
                  />
                </div>
                <p
                  style="
                    font-size: 16px;
                    color: #ac0000;
                    margin-bottom: 0;
                    font-weight: 400;
                  "
                >
                  Para guardar un PCL es necesario llenar los campos y
                  documentos requeridos *.
                </p>
              </div>
            </b-alert>
          </b-col>
        </b-row>

        <div
          class="mt-5 d-flex justify-content-end mb-5"
          v-if="!loading && !isEdit"
        >
          <button
            class="button_primary"
            @click.prevent="saveDiagnostic"
            :disabled="isBusy || isValidation"
          >
            Guardar {{ !record ? "PCL" : "cambios" }}
            <b-spinner v-if="isBusy" />
          </button>
        </div>
      </template>
    </layout>
    <!-- 3 MODAL PROCESO EXITOSO  -->
    <modal-success :messageModal="messageModal" />

    <!-- 4 MODAL PROCESO FALLIDO -->
    <modal-error :error="error" />
  </div>
</template>

<script>
import {
  getDiagnostics,
  savePCL,
  editPCL,
  detailPCL,
} from "@/services/health-tracker/diagnostic/service";
import FormPCL from "./components/FormPCL.vue";
import ModalSuccess from "@/views/SVE/modals/ModalSuccess.vue";
import ModalError from "@/views/SVE/modals/ModalError.vue";

export default {
  name: "createPCL",
  components: {
    layout: () => import("@/layouts/modules/health-tracker/v2/app.vue"),
    WorkerInformation: () =>
      import(
        "@/components/Modules/HealthTracker/V2/Common/WorkerInformation/WorkerInformation.vue"
      ),
    FormPCL,
    ModalSuccess,
    ModalError,
  },
  data: () => ({
    formData: {
      diagnostic_ids: null,
      compensation: null,
      pcl_document_date: "",
      compensation_date: "",
      file: null,
      percentage: "",
    },
    isBusy: false,
    loading: false,
    isEdit: false,
    diagnostics: [],
    messageModal: "PCL guardado exitosamente",
    error: {
      message: "",
    },
    record: null,
  }),
  computed: {
    employeeId() {
      return parseInt(this.$route.params.employee_id || "0");
    },
    pclId() {
      return parseInt(this.$route.params.pcl_id || "0");
    },
    isValidation() {
      const me = this;
      let isValidation = true;
      const isCompensationDate =
        me.formData?.compensation?.id == "with_compensation" &&
        me.formData.compensation_date == ""
          ? true
          : false;
      isValidation =
        me.formData.diagnostic_ids?.length > 0 &&
        me.formData.compensation?.id &&
        me.formData.pcl_document_date !== "" &&
        !isCompensationDate &&
        me.formData.percentage !== ""
          ? false
          : true;

      return isValidation;
    },
    nameForm() {
      const me = this;
      let text = "Nueva";
      if (me.pclId > 0 && !me.isEdit) {
        text = "Editar";
      } else if (me.pclId > 0 && me.isEdit) {
        text = "Detalle";
      }
      return text;
    },
  },
  methods: {
    changeForm(formData) {
      const me = this;
      me.formData = {
        ...me.formData,
        ...formData,
      };
    },
    async saveDiagnostic() {
      const me = this;
      me.isBusy = true;
      const formData = me.parseData();
      try {
        me.record ? await editPCL(formData, me.pclId) : await savePCL(formData);
        me.$bvModal.show("modal-success");
        setTimeout(() => {
          me.back();
        }, 5000);
      } catch (error) {
        me.error.message = "Error al guardar Formulario";
        me.$bvModal.show("modal-fail");
      } finally {
        me.isBusy = false;
      }
    },
    async loadPcl() {
      const me = this;
      me.loading = true;
      try {
        const { data } = await detailPCL(me.pclId);
        me.record = data;
      } catch (error) {
        console.log(error);
      } finally {
        me.loading = false;
      }
    },
    async loadDiagnostics() {
      const me = this;
      me.diagnostics = [];
      try {
        const { data } = await getDiagnostics(me.employeeId);
        data?.data.forEach((x) => {
          me.diagnostics.push({
            id: x.id,
            name: x.code_name,
          });
        });
      } catch (error) {
        console.log(error);
      }
    },
    parseData() {
      const me = this;
      const formData = new FormData();
      formData.append("core_employee_id", me.employeeId);

      const diagnostic_ids = me.formData.diagnostic_ids.map((x) => x.id + "");
      diagnostic_ids.forEach((id) => formData.append("diagnostic_ids[]", id));

      me.formData.compensation !== null &&
        formData.append("compensation", me.formData.compensation?.id || null);
      me.formData.pcl_document_date !== "" &&
        formData.append("pcl_document_date", me.formData.pcl_document_date);
      me.formData.compensation_date !== "" &&
        formData.append("compensation_date", me.formData.compensation_date);
      me.formData.percentage !== "" &&
        formData.append("percentage", me.formData.percentage);
      me.formData.file !== null && formData.append("file", me.formData.file);

      return formData;
    },
    back() {
      const me = this;
      me.$router.push({
        name: "sve",
        params: {
          category: "diagnostics-register",
          type: me.employeeId,
        },
      });
    },
  },
  async mounted() {
    const me = this;
    await me.loadDiagnostics();
    const params = me.$route.params.is_edit || null;
    me.isEdit = params && params !== "false" ? false : true;
    if (me.pclId > 0) me.loadPcl();
    // if (this.employeeId < 1)
    //   return this.$router.push({ name: "errorPage", params: { code: 400 } });
  },
};
</script>

<style lang="scss">
.alert-danger-form-ipt {
  border: 1px solid #ac0000 !important;
  border-radius: 4px !important;
  background-color: #ffdfdf !important;
  margin-bottom: 40px;
}
.hr-form-ipt {
  border-bottom: 1px solid #c9caff !important;
  margin: 16px 0 !important;
}
.breadcrumb-link {
  color: #5d5fef;
  font-family: "Ubuntu";
  font-style: normal;
  font-weight: 700;
  font-size: 12px;
  line-height: 16px;
  margin-top: 0.125em;
}
</style>
